import { fromJS } from 'immutable';
import { CREATE_GAME, CREATE_GAME_SUCCESS, DELETE_GAMES, GET_GAMES, SET_GAMES } from './constants';

export const createGame = (opponentId) => ({
  type: CREATE_GAME,
  payload: fromJS({ opponentId }),
});

export const createGameSuccess = () => ({
  type: CREATE_GAME_SUCCESS,
});

/** Deletes games from the list: one (its tile's Delete) or several (selected). */
export const deleteGames = (gameIds) => ({
  type: DELETE_GAMES,
  payload: fromJS({ gameIds }),
});

export const getGames = () => ({
  type: GET_GAMES,
});

export const setGames = (games) => ({
  type: SET_GAMES,
  payload: fromJS({ games }),
});